import { Injectable } from '@angular/core';
import { SyncLoggingService } from '../../logging';
import { DatabaseService, DatabaseServiceOptions, upgraded } from '../../offline-first';

const objectStores = {
  exerciseProgramDocuments: { keyPath: 'key' },
  exerciseProgramDocumentsCache: { keyPath: 'key' },
  planDocuments: { keyPath: 'key' },
  planDocumentsCache: { keyPath: 'key' },
  plans: { keyPath: 'key' },
  workoutSessionDocuments: { keyPath: 'key' },
  userLibraryDocuments: { keyPath: 'key' },
  userLibraryDocumentsCache: { keyPath: 'key' },
  observationDocuments: { keyPath: 'key' },
};

@Injectable({
  providedIn: 'root',
})
export class DocumentDatabaseService extends DatabaseService {
  static version = 5;
  static dbName = 'fitforce-planner-documents';

  public options: DatabaseServiceOptions  = {
    dbName: DocumentDatabaseService.dbName,
    version: DocumentDatabaseService.version,
    objectStores,
    seed: {},
    upgraded,
  };

  constructor(syncLog: SyncLoggingService) {
    super(syncLog);
  }
}
